module.exports = __webpack_public_path__ + "img/trip-fuel-coaching-1.406fe1ee.svg";